module.exports = __webpack_public_path__ + "img/dd_orange.da149fe0.svg";